/*
 * @Author       : Archer<ahh666@qq.com>
 * @Date         : 2023-02-07 11:37:47
 * @LastEditors  : Archer<ahh666@qq.com>
 * @LastEditTime : 2023-02-07 14:14:33
 * @FilePath     : \youxi\youxi\src\components\LeaveMsg\Success.jsx
 * @Description  : Description
 */

export default {
  methods: {
    closeWindow() {
      window.back();
    }
  },
  render() {
    return (
      <div class="leave-msg__success-wrap">
        <i class="leave-msg__success-icon el-icon-success"></i>
        <div class="leave-msg__success-text">提交成功</div>
        <div class="leave-msg__success-desc">
          我们会尽快给您回复，请保持通讯畅通！感谢您对游严选账号的支持与厚爱
        </div>
        <el-button
          class="leave-msg__success-btn__back"
          type="primary"
          onClick={() => window.close()}
        >
          返回聊天窗
        </el-button>
      </div>
    );
  }
};
